/* TOPNAVI · Változat-összehasonlító — v3 (2026-09-20)
   Tulaj: „az Ezt választom alatt legyen az összehasonlítás és alul jelenjen meg
   egy bar… mobilon ne zavarjon be… ha mindegyik tudja, azt is mutasd."

   Felépítés:
     · a kártyákon „Összehasonlítom" jelölőnégyzet (data-tn-cmp-add),
     · alul sáv a kijelöltekkel — csak akkor látszik, ha van kijelölés,
       mobilon a ragadós kosár-sáv fölött, bezárható,
     · a felugró ablakban a sorok CSOPORTOKBA rendezve; elöl az eltérések,
       külön szekcióban az, amit mindegyik tud.

   Adat: [data-tn-cmp-data] — a kártyákkal azonos forrásból (tk_* tömbök +
   alt_headunits), plusz a custom.specs metamező (TopApp Eszköz-katalógus). */
(function () {
  'use strict';
  if (window.__tnCompare) return;
  window.__tnCompare = true;

  var MAX = 3;
  var picked = [];
  var data = null;
  var rootEl = null;

  function root() {
    if (!rootEl) rootEl = document.querySelector('[data-pd]') || document;
    return rootEl;
  }

  function load() {
    if (data) return data;
    var el = root().querySelector('[data-tn-cmp-data]');
    if (!el) return null;
    try { data = JSON.parse(el.textContent); } catch (e) { data = null; }
    return data;
  }

  function itemOf(id) {
    var d = load();
    if (!d) return null;
    for (var i = 0; i < d.items.length; i++) if (d.items[i].id === id) return d.items[i];
    return null;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* ── adatsorok ─────────────────────────────────────────────────────────── */
  function specsOf(it) {
    var out = {};
    var raw = it && it.specsRaw;
    if (!raw) return out;
    var list = [].concat(raw.common || []);
    if (it.tierKey && raw.tiers && raw.tiers[it.tierKey]) list = list.concat(raw.tiers[it.tierKey]);
    list.forEach(function (r) {
      /* 2026-09-23: a TopApp-katalógus „TESZT…” jelölésű próbaértéke soha ne jelenjen meg a vevőnek */
      if (r && r.k && !/^\s*TESZT/i.test(String(r.v || ''))) out[r.k] = { v: r.v, g: r.g || 'További adatok' };
    });
    return out;
  }

  function buildRows(d, cols) {
    var maps = cols.map(specsOf);
    var rows = [];
    (d.rows || []).forEach(function (r) {
      rows.push({
        group: r[2] || 'Alapok',
        label: r[1],
        vals: cols.map(function (c) { return (c.cells && c.cells[r[0]]) || '–'; })
      });
    });
    var seen = {};
    maps.forEach(function (m) {
      Object.keys(m).forEach(function (k) {
        if (seen[k]) return;
        seen[k] = true;
        rows.push({
          group: m[k].g,
          label: k,
          vals: maps.map(function (mm) { return mm[k] ? mm[k].v : '–'; })
        });
      });
    });
    rows.forEach(function (r) {
      r.same = r.vals.every(function (v) { return v === r.vals[0]; }) && r.vals[0] !== '–';
    });
    return rows;
  }

  /* ── felugró ablak ─────────────────────────────────────────────────────── */
  function renderModal() {
    var box = root().querySelector('[data-tn-cmp]');
    var d = load();
    if (!box || !d) return;
    var picks = box.querySelector('[data-tn-cmp-picks]');
    var table = box.querySelector('[data-tn-cmp-table]');
    var foot = box.querySelector('[data-tn-cmp-foot]');

    /* felül CSAK a kijelöltek; a többi a lenyithatóban (tulaj: ne tolja le a táblát) */
    var pool = box.querySelector('[data-tn-cmp-pool]');
    var chip = function (it, on) {
      return '<button type="button" class="tn-cmp__chip' + (on ? ' is-on' : '') + '' +
        ' data-cmp-id="' + esc(it.id) + '">' +
        (it.img ? '<img src="' + esc(it.img) + '" alt="">' : '') +
        '<b>' + esc(it.name) + '</b>' +
        (it.price ? '<span>' + esc(it.price) + '</span>' : '') +
        (on ? '<i aria-hidden="true">&times;</i>' : '') + '</button>';
    };
    picks.innerHTML = d.items.filter(function (it) { return picked.indexOf(it.id) >= 0; })
      .map(function (it) { return chip(it, true); }).join('');
    if (pool) {
      var rest = d.items.filter(function (it) { return picked.indexOf(it.id) < 0; });
      pool.innerHTML = rest.map(function (it) { return chip(it, false); }).join('');
      var more = box.querySelector('[data-tn-cmp-more]');
      if (more) more.hidden = rest.length === 0;
    }
    var cols = d.items.filter(function (it) { return picked.indexOf(it.id) >= 0; });
    if (cols.length < 2) {
      table.innerHTML = '<tbody><tr><td class="tn-cmp__empty">Jelölj ki legalább kettőt — azokat tesszük egymás mellé.</td></tr></tbody>';
      if (foot) foot.hidden = true;
      return;
    }

    var rows = buildRows(d, cols);
    var diff = rows.filter(function (r) { return !r.same; });
    var same = rows.filter(function (r) { return r.same; });

    var html = '<thead><tr><th class="tn-cmp__rowhead"></th>';
    cols.forEach(function (c) {
      html += '<th><span class="tn-cmp__ch">'
        + (c.img ? '<img class="tn-cmp__cimg" src="' + esc(c.img) + '" alt="">' : '<span class="tn-cmp__cimg tn-cmp__cimg--none"></span>')
        + '<span class="tn-cmp__cwrap"><span class="tn-cmp__cname">' + esc(c.name) + '</span>'
        + '<span class="tn-cmp__cprice">' + esc(c.price || '') + '</span></span>'
        + '</span></th>';
    });
    html += '</tr></thead><tbody>';

    var lastGroup = '';
    diff.forEach(function (r) {
      if (r.group !== lastGroup) {
        lastGroup = r.group;
        html += '<tr class="tn-cmp__gr"><th scope="row" colspan="' + (cols.length + 1) + '">' + esc(r.group) + '</th></tr>';
      }
      html += '<tr class="is-diff"><th scope="row">' + esc(r.label) + '</th>'
        + r.vals.map(function (v) { return '<td>' + esc(v) + '</td>'; }).join('') + '</tr>';
    });

    if (!diff.length) {
      html += '<tr><td class="tn-cmp__empty" colspan="' + (cols.length + 1) + '">Ezek között nincs eltérés — minden adat megegyezik.</td></tr>';
    }

    if (same.length) {
      html += '<tr class="tn-cmp__gr tn-cmp__gr--same"><th scope="row" colspan="' + (cols.length + 1) + '">'
        + 'Mindegyik tudja <small>' + same.length + ' azonos adat</small></th></tr>';
      same.forEach(function (r) {
        html += '<tr class="is-same"><th scope="row">' + esc(r.label) + '</th>'
          + r.vals.map(function (v) { return '<td>' + esc(v) + '</td>'; }).join('') + '</tr>';
      });
    }

    html += '<tr class="tn-cmp__ctarow"><th scope="row"></th>'
      + cols.map(function (c) {
          return '<td>' + (c.url
            ? '<a class="tn-cmp__cta" href="' + esc(c.url) + '">Megnézem</a>'
            : '<button type="button" class="tn-cmp__cta" data-cmp-pick="' + esc(c.tierKey || '') + '">Ezt választom</button>') + '</td>';
        }).join('') + '</tr></tbody>';
    table.innerHTML = html;

    if (foot) {
      foot.hidden = false;
      foot.innerHTML = '<span class="tn-cmp__hint"><b>' + diff.length + '</b> eltérés · <b>' + same.length
        + '</b> közös adat · legfeljebb ' + MAX + ' változat</span>';
    }
  }

  /* ── alsó sáv ──────────────────────────────────────────────────────────── */
  function renderBar() {
    var bar = root().querySelector('[data-tn-cbar]');
    if (!bar) return;
    if (!picked.length) { bar.hidden = true; document.body.classList.remove('has-cbar'); return; }
    bar.hidden = false;
    document.body.classList.add('has-cbar');

    var items = bar.querySelector('[data-tn-cbar-items]');
    var n = bar.querySelector('[data-tn-cbar-n]');
    items.innerHTML = picked.map(function (id) {
      var it = itemOf(id);
      if (!it) return '';
      return '<span class="tn-cbar__i">'
        + (it.img ? '<img src="' + esc(it.img) + '" alt="">' : '')
        + '<b>' + esc(it.name) + '</b>'
        + (it.price ? '<span>' + esc(it.price) + '</span>' : '')
        + '<button type="button" data-tn-cbar-rm="' + esc(id) + '" aria-label="Kiveszem">&times;</button>'
        + '</span>';
    }).join('');
    if (n) n.textContent = String(picked.length);
    var go = bar.querySelector('[data-tn-cmp-open]');
    if (go) go.disabled = picked.length < 2;
  }

  function syncButtons() {
    root().querySelectorAll('[data-tn-cmp-add]').forEach(function (b) {
      b.classList.toggle('is-on', picked.indexOf(b.getAttribute('data-tn-cmp-add')) >= 0);
    });
  }

  function toggle(id) {
    var at = picked.indexOf(id);
    if (at >= 0) picked.splice(at, 1);
    else { picked.push(id); if (picked.length > MAX) picked.shift(); }
    syncButtons();
    renderBar();
    var box = root().querySelector('[data-tn-cmp]');
    if (box && !box.hidden) renderModal();
  }

  function open() {
    var box = root().querySelector('[data-tn-cmp]');
    var d = load();
    if (!box || !d || !d.items || d.items.length < 2) return;
    if (picked.length < 2) {
      /* alapértelmezés: az első androidos + az első márkás */
      var first = d.items[0];
      var brand = d.items.filter(function (i) { return i.group === 'brand'; })[0];
      picked = [first.id, (brand || d.items[1]).id];
      syncButtons();
      renderBar();
    }
    renderModal();
    box.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var x = box.querySelector('[data-tn-cmp-close]');
    if (x) x.focus();
  }

  function close(box) {
    box.hidden = true;
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var add = t.closest('[data-tn-cmp-add]');
    if (add) { e.preventDefault(); toggle(add.getAttribute('data-tn-cmp-add')); return; }

    var rm = t.closest('[data-tn-cbar-rm]');
    if (rm) { e.preventDefault(); toggle(rm.getAttribute('data-tn-cbar-rm')); return; }

    if (t.closest('[data-tn-cbar-clear]')) {
      picked = []; syncButtons(); renderBar();
      var b0 = root().querySelector('[data-tn-cmp]');
      if (b0 && !b0.hidden) close(b0);
      return;
    }

    if (t.closest('[data-tn-cmp-open]')) { e.preventDefault(); open(); return; }

    var box = t.closest('[data-tn-cmp]');
    if (!box) return;

    if (t.closest('[data-tn-cmp-close]') || t === box) { close(box); return; }

    var pick = t.closest('[data-cmp-pick]');
    if (pick) {
      var key = pick.getAttribute('data-cmp-pick');
      var card = key && document.querySelector('[data-pd-tc="' + key + '"] [data-pd-pick]');
      close(box);
      if (card) card.click();
      return;
    }

    var chip = t.closest('[data-cmp-id]');
    if (chip) toggle(chip.getAttribute('data-cmp-id'));
  }, false);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var box = document.querySelector('[data-tn-cmp]:not([hidden])');
    if (box) close(box);
  });
})();
